import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Scenics from "./components/Scenics";
import PhotoGrid from "./components/PhotoGrid";
import { translateCategory } from "./services/translations";
import "./index.css";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to English
    const savedLanguage = localStorage.getItem("preferred_language");
    return savedLanguage || "en";
  });

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await fetch("/uploads/index.json");
      const data = await response.json();

      // Remove carousel from the list
      const filteredData = data.filter((category) => category !== "carousel");

      setCategories(filteredData);
    };
    fetchCategories();
  }, []);

  // Save language preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("preferred_language", language);
  }, [language]);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  const NavLinks = (mobile = false) => {
    const linkClasses = mobile
      ? "block text-lg py-2 border-b border-gray-300"
      : "hover:text-gray-500";

    return categories.map((category) => {
      const translatedCategory = translateCategory(category, language);

      return (
        <a key={category} href={`/gallery/${category}`} className={linkClasses}>
          {translatedCategory}
        </a>
      );
    });
  };

  return (
    <Router>
      <div className='min-h-screen bg-secondary'>
        <nav className='fixed top-0 w-full bg-secondary p-4 z-50'>
          <div className='container mx-auto flex justify-between items-center'>
            <div className='flex items-center space-x-3'>
              <a href='/' className='text-xl font-bold'>
                <img src='/83574.png' style={{ height: "20px" }} alt='logo' />
              </a>
              {/* Language Switcher */}
              <div className='flex items-center space-x-1'>
                <button
                  onClick={() => handleLanguageChange("en")}
                  className={`transition-all ${
                    language === "en"
                      ? "opacity-100"
                      : "opacity-50 hover:opacity-75"
                  }`}
                  aria-label='Switch to English'
                  title='English'
                >
                  <span className='text-lg'>🇺🇸</span>
                </button>
                <span className='text-gray-400 mx-1'>|</span>
                <button
                  onClick={() => handleLanguageChange("pt")}
                  className={`transition-all ${
                    language === "pt"
                      ? "opacity-100"
                      : "opacity-50 hover:opacity-75"
                  }`}
                  aria-label='Switch to Portuguese'
                  title='Português'
                >
                  <span className='text-lg'>🇧🇷</span>
                </button>
              </div>
            </div>

            <div className='flex items-center space-x-4'>
              {/* Desktop nav */}
              <div className='hidden md:flex space-x-6 items-center'>
                <NavLinks />
              </div>

              <button
                className='md:hidden focus:outline-none'
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label='Toggle menu'
              >
                <svg
                  className='w-6 h-6'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d={
                      menuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile menu dropdown */}
          {menuOpen && (
            <div className='md:hidden mt-2 px-4 space-y-2'>
              <NavLinks mobile />
            </div>
          )}
        </nav>

        <main className='pt-20'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route
              path='/gallery/scenics'
              element={<Scenics language={language} />}
            />
            <Route
              path='/gallery/:category'
              element={<PhotoGrid language={language} />}
            />
            <Route
              path='/gallery/:category/:subcategory'
              element={<PhotoGrid language={language} />}
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
